import * as yup from 'yup'

export const schema = yup.object({
    periodoInicial: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    periodoFinal: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    status: yup.string(),
    ufDetran: yup.string(),
    tipoOperacao: yup.string(),
    chassi: yup.string(),
    numeroContrato: yup.string(),
    numeroGravame: yup.string(),
    origem: yup.string()
})
